import './Tab.css'
import cx from 'classnames'
import React from 'react'

const sizeClasses = {
  xs: 'tab-xs',
  sm: 'tab-sm',
  md: 'tab-md',
  lg: 'tab-lg'
}

export function Tab({
  className,
  children,
  isActive = false,
  sizeType = 'sm',
  disabled
}: {
  className?: string
  children: React.ReactNode
  isActive: boolean
  sizeType?: 'xs' | 'sm' | 'md' | 'lg'
  disabled?: boolean
}) {
  const stateClass = isActive ? 'tab-active' : disabled ? 'tab-disabled' : 'tab-inactive'

  return (
    <div className={cx('tab-base', stateClass, 'tab-hover', sizeClasses[sizeType], className)}>
      {children}
    </div>
  )
}
